import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { compact } from 'lodash-es';
import { BottomSheetContentLayout, MobileSummaryCard, TextButton } from 'seagull';
import { PlusCircleLine } from 'seagull/icons';
import { getTestIds } from 'seagull/utils/TestIds';
export const GetMobileFilterListTID = (parentTestId)=>getTestIds(parentTestId);
export const MobileFilterList = (param)=>{
    let { testId, filterLabels, draftFilterKeys, hasAvailableFilters, onRemoveFilter, onFilterClick, onAddFilterClick, onApply } = param;
    const { MobileFilterListTID } = useMemo(()=>GetMobileFilterListTID(testId), [
        testId
    ]);
    return /*#__PURE__*/ _jsx(BottomSheetContentLayout, {
        contentGutter: "m",
        footer: {
            paddingTop: 8,
            primaryAction: {
                text: 'Apply',
                onClick: onApply,
                testId: MobileFilterListTID.ApplyButton()
            }
        },
        children: /*#__PURE__*/ _jsx(MobileSummaryCard, {
            title: "Filters",
            testId: MobileFilterListTID.Root(),
            items: compact([
                ...draftFilterKeys.map((filterKey)=>({
                        title: filterLabels[filterKey],
                        titleTestId: MobileFilterListTID.FilterRow(String(filterKey)),
                        actions: [
                            {
                                type: 'edit',
                                testId: MobileFilterListTID.EditButton(String(filterKey)),
                                onClick: ()=>onFilterClick(filterKey)
                            },
                            {
                                type: 'remove',
                                testId: MobileFilterListTID.RemoveButton(String(filterKey)),
                                onClick: ()=>onRemoveFilter(filterKey)
                            }
                        ]
                    })),
                hasAvailableFilters && {
                    body: /*#__PURE__*/ _jsx(TextButton, {
                        testId: MobileFilterListTID.AddFilterButton(),
                        underline: "none",
                        weight: "normal",
                        prefixIcon: /*#__PURE__*/ _jsx(PlusCircleLine, {}),
                        onClick: onAddFilterClick,
                        children: "Add filter"
                    })
                }
            ])
        })
    });
};
